module.exports = __webpack_public_path__ + "media/images/temp/icon-8-940907e694c5ef134516e67a7d4da5b7.png";